// Array with all possible permissions that could be added to routes or roles for workflow
const WorkflowRoutePermissionsData = [
    {
        permissionId: "View",
        permissionName: "View"
    },  
    {
        permissionId: "Query",
        permissionName: "Query"
    },
    {
        permissionId: "Verify",
        permissionName: "Verify"
    },   
    {
        permissionId: "Approve",
        permissionName: "Approve"
    },
    // {
    //     permissionId: "Attest",
    //     permissionName: "Attest"
    // },  
  
    {
        permissionId: "Reject",
        permissionName: "Reject"
    },

]


export default WorkflowRoutePermissionsData